import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconClapboardWide"><Path d="M22 17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V10.5H22V17.25Z" fill="currentColor"/><Path d="M6.75098 9H2V6.75C2 5.23122 3.23122 4 4.75 4H8.41797L6.75098 9Z" fill="currentColor"/><Path d="M14 9H8.33301L10 4H15.667L14 9Z" fill="currentColor"/><Path d="M22 9H15.582L17.249 4H19.25C20.7688 4 22 5.23122 22 6.75V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboardWide;
